/**
 * @generated SignedSource<<eb25b399052020c7ccc3dd130ece1604>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addMoqRulePanel_AssignProductMutation$variables = {
  moqRuleId: string;
  productIds: ReadonlyArray<number>;
};
export type addMoqRulePanel_AssignProductMutation$data = {
  readonly assignProductsToMoqRule: {
    readonly result: boolean;
  };
};
export type addMoqRulePanel_AssignProductMutation = {
  response: addMoqRulePanel_AssignProductMutation$data;
  variables: addMoqRulePanel_AssignProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "moqRuleId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "moqRuleId",
        "variableName": "moqRuleId"
      },
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToMoqRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addMoqRulePanel_AssignProductMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "addMoqRulePanel_AssignProductMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "171f408caa5061a2682a3b8497fe6d84",
    "id": null,
    "metadata": {},
    "name": "addMoqRulePanel_AssignProductMutation",
    "operationKind": "mutation",
    "text": "mutation addMoqRulePanel_AssignProductMutation(\n  $moqRuleId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToMoqRule(moqRuleId: $moqRuleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "d22f8b6a7f1cc79db542969f4b23fd03";

export default node;
